import { TitleBigWrapper } from "./styled";

export const TitleBig = (props) => {
  return (
    <TitleBigWrapper margin={props.margin}>{props.children}</TitleBigWrapper>
  );
};
